<zah-clienten-overzicht-regioverantwoordelijke [initialPageRequest]="initialPageRequest"
              [clientenPage]="clientenPage$ | async"
              [zones]="zones$ | async"
              [diensten]="diensten$ | async"
              (clientClicked)="navigateToClient($event)"
              (meldingenClicked)="navigateToMeldingen($event)"
              (prestatiesClicked)="navigateToPrestaties($event)"
              (signaalkaartenClicked)="navigateToSignaalkaarten($event)"
              (wijzigClientClicked)="navigateToEditClient($event)"
              (clientFicheClicked)="navigateToClientFiche($event)"
              (archiveClicked)="archiveClient($event)"
              (unarchiveClicked)="unarchiveClient($event)"
              (addClicked)="navigateToAddClient()"
              (pageChange)="onPageChange($event)">
</zah-clienten-overzicht-regioverantwoordelijke>
